import { List } from 'immutable';

// helper method for each selector
const getSelectedElements = (state, props, key, mapper) => {
  const elements = state.bookings[key];
  let selected = new List();

  // Immutable List()
  const selectedParkingPassIds = props.selectedParkingPassIds || state.bookings.selectedParkingPassIds;

  if (elements) {
    selected = selectedParkingPassIds
      .map(id => mapper(id, elements))
      .filter(booking => booking);
  }

  return selected;
};

/**
 * Gets Bookings for Selected Parking Passes
 * @param  {ReduxStore} state
 *         Redux store
 * @param  {Object} props
 *         Component Props
 * @return {List}
 *         List of Bookings for Selected Parking Passes
 */
export const getSelectedBookings = (state, props) => (
  getSelectedElements(state, props, 'bookings', (id, elements) => elements.get(id))
);

/**
 * Gets Selected Parking Passes
 * @param  {ReduxStore} state
 *         Redux store
 * @param  {Object} props
 *         Component Props
 * @return {List}
 *         List of Selected Parking Passes
 */
export const getSelectedParkingPasses = (state, props) => (
  getSelectedElements(state, props, 'parkingPasses', (id, elements) => elements.get(id.toString()))
);
